import { Box } from '@mui/material';
import CNLoading from '../loading-cn/CNLoading';

export default function LoadingPage() {
  return (
    <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
      <CNLoading />
    </Box>
  );
}
